"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledButtonBase = exports.classes = void 0;
const ButtonBase_1 = __importDefault(require("@mui/material/ButtonBase"));
const styles_1 = require("@mui/material/styles");
const PREFIX = "ToggleCard";
exports.classes = {
    body: `${PREFIX}-body`,
    title: `${PREFIX}-title`,
    only: `${PREFIX}-only`,
    paragraph: `${PREFIX}-paragraph`,
    image: `${PREFIX}-image`,
    contain: `${PREFIX}-contain`,
    disabled: `${PREFIX}-disabled`
};
exports.StyledButtonBase = (0, styles_1.styled)(ButtonBase_1.default)(({ theme }) => ({
    display: "block",
    width: "100%",
    height: "100%",
    borderRadius: "4px",
    "&:hover": {
        [`.${exports.classes.body}`]: {
            boxShadow: "0px 5px 5px -3px rgba(0, 0, 0, 0.2), 0px 8px 10px 1px rgba(0, 0, 0, 0.14), 0px 3px 14px 2px rgba(0, 0, 0, 0.12)"
        },
        [`.${exports.classes.image}`]: {
            opacity: 1
        },
        [`.${exports.classes.title}`]: {
            color: theme.colours.focus
        },
        [`.${exports.classes.paragraph}`]: {
            color: theme.colours.charcoal
        }
    },
    "&:focus": {
        outline: `1px solid ${theme.colours.accent}`
    },
    [`.${exports.classes.body}`]: {
        display: "flex",
        padding: "20px",
        height: "100%",
        width: "100%",
        justifyContent: "center",
        flexDirection: "column",
        boxShadow: "0px 1px 3px 0px rgba(0, 0, 0, 0.2), 0px 1px 1px 0px rgba(0, 0, 0, 0.14), 0px 2px 1px -1px rgba(0, 0, 0, 0.12)"
    },
    [`& .${exports.classes.title}`]: {
        wordWrap: "break-word",
        textAlign: "center",
        color: theme.colours.focus
    },
    [`.${exports.classes.only}`]: {
        marginTop: "16px",
        marginBottom: "16px"
    },
    [`.${exports.classes.paragraph}`]: {
        marginTop: "16px",
        wordWrap: "break-word",
        textAlign: "center",
        color: theme.colours.slate
    },
    [`.${exports.classes.image}`]: {
        backgroundRepeat: "no-repeat",
        backgroundPosition: "center center",
        backgroundSize: "contain",
        height: "140px",
        maxWidth: "100%",
        opacity: 0.8,
        marginBottom: "16px",
        transition: "opacity 280ms cubic-bezier(0.4, 0, 0.2, 1)",
        padding: "20px 20px 20px 20px",
        img: {
            "&:not(.png)": {
                width: "100%"
            }
        },
        [theme.breakpoints.up("sm")]: {
            height: "96px",
            padding: 0
        }
    },
    [`.${exports.classes.contain}`]: {
        backgroundSize: "contain"
    },
    [`.${exports.classes.disabled}`]: {
        [`.${exports.classes.body}`]: {
            boxShadow: "0px 1px 3px 0px rgba(0, 0, 0, 0.2), 0px 1px 1px 0px rgba(0, 0, 0, 0.14), 0px 2px 1px -1px rgba(0, 0, 0, 0.12)"
        },
        [`.${exports.classes.image}`]: {
            opacity: 0.35
        },
        [`.${exports.classes.title}`]: {
            color: theme.colours.focus,
            opacity: 0.35
        },
        [`.${exports.classes.paragraph}`]: {
            color: theme.colours.slate,
            opacity: 0.35
        }
    }
    // Generics work fine as a ButtonBase, but not as a styled ButtonBase,
    // so the `component` property isn't accepted
}));
//# sourceMappingURL=data:application/json;base64,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